import React from "react";
import { Typography, Grid, Link, Divider, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
// import Logo from "../../Landing/components/Logo";
import clsx from "clsx";
import CustomButton from "../components/CustomButton";
import LinkedInIcon from "../../Landing/components/LinkedInIcon";
import TwitterIcon from "../../Landing/components/TwitterIcon";
import TelegramIcon from "../../Landing/components/TelegramIcon";
import InstagramIcon from "../../Landing/components/InstagramIcon";
const useStyles = makeStyles({
  footer: {
    minHeight: "90vh",
    height: "auto",
    width: "100%",
    background: "url(/images/teacher_bg.jpg) no-repeat center bottom",
    backgroundSize: "cover",
    position: "relative",

    "&::before": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundImage: "linear-gradient(68deg, #4938cb, #3721d2, #26189b)",
      opacity: 0.5,
    },
  },

  actionBar: {
    display: "flex",
    alignItems: "center",
    padding: "32px 64px",
    position: "relative",
    color: "white",
    "& img": {
      height: 32,
      margin: "0px 8px",
    },
  },

  center: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    position: "relative",
    color: "white",
    padding: "8px 8vw",
  },
  centerText: {
    textAlign: "initial",
  },
  footerTitle: {
    fontSize: "55px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    marginTop: 64,

    lineHeight: "normal",
    letterSpacing: "normal",
  },
  footerDescription: {
    fontSize: "30px",
    fontWeight: 300,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    marginTop: 22,
    letterSpacing: "normal",
    maxWidth: "50vw",
  },
  logo: {
    margin: "0px 8px",
  },
  applyButton: {
    margin: "10% auto",
    marginTop: 128,
    padding: "8px 56px",
    fontWeight: "normal",
    fontSize: 18,
  },
  bigFooter: {
    backgroundColor: "#212940",
    padding: "2vw 64px 0px 4vw",
    "& a": {
      color: "white",
    },
  },
  linkList: {
    display: "flex",
    flexDirection: "column",
    "& a": {
      marginTop: 10,
    },
  },
  divider: {
    marginTop: 64,
    backgroundColor: "white",
  },
  copyright: {
    display: "flex",
    color: "white",
    padding: "1rem",
    alignItems: "center",
  },
  grow: {
    flexGrow: 1,
  },
  icon: {
    padding: 6,
  },
});

export default function Footer(props) {
  const classes = useStyles();
  const { setShowForm } = props;

  const openLink = (link) => (_) => window.open(link, "_blank");

  return (
    <section>
      <footer className={classes.footer}>
        <section className={classes.center}>
          <Typography
            className={clsx(classes.centerText, classes.footerTitle)}
            variant="h5"
          >
            با آموزش زبان به دیگران، درآمد کسب کنید‬
          </Typography>
          <Typography
            className={clsx(classes.centerText, classes.footerDescription)}
            variant="h5"
          >
            لینگوتاک، پلتفرم آموزش زبان آنلاین‬
          </Typography>
          <br />
          <br />
          <br />
          <br />
          <CustomButton
            id="footer-start-teaching"
            color="green"
            size="large"
            className={classes.applyButton}
            onClick={() => setShowForm(true)}
          >
            {/* <a
              style={{
                height: "100%",
                width: "100%",
                color: "white",
                textDecoration: "none"
              }}
              href="/register/teacher"
            > */}
            ثبت نام استاد
            {/* </a> */}
          </CustomButton>

          <br />
          <br />
        </section>
      </footer>
      <footer className={classes.bigFooter}>
        <Grid container>
          <Grid item xs={12} md={4}>
            <Grid container>
              <Grid item xs={6} className={classes.linkList}>
                <Link href="#">درباره ما</Link>
                <Link href="#">لینگوتاک چگونه کار می کند؟</Link>
                <Link href="#">راهنما</Link>
                <Link href="#">تماس با ما</Link>
              </Grid>
              <Grid item xs={6} className={classes.linkList}>
                <Link className={classes.link} href="#">
                  جذب استاد
                </Link>
                <Link className={classes.link} href="#">
                  وبلاگ
                </Link>
                <Link className={classes.link} href="#">
                  فرصت های همکاری
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
        </Grid>
        <Divider className={classes.divider} />
        <section className={classes.copyright}>
          <Typography variant="body2">
            {" "}
            کپی رایت {new Date().getFullYear()} - کلیه حقوق برای لینگوتاک محفوظ
            است.
          </Typography>
          <div className={classes.grow} />
          <a target="_blank" href="https://www.linkedin.com/company/lingotalk">
            <IconButton
              size="small"
              onClick={openLink("https://www.linkedin.com/company/lingotalk")}
            >
              <LinkedInIcon color="#ffffff" className={classes.icon} />
            </IconButton>
          </a>
          <a target="_blank" href="https://twitter.com/lingotalk1">
            <IconButton
              size="small"
              onClick={openLink("https://twitter.com/lingotalk1")}
            >
              <TwitterIcon color="#ffffff" className={classes.icon} />
            </IconButton>
          </a>
          <a target="_blank" href="https://t.me/lingotalk">
            <IconButton
              size="small"
              onClick={openLink("https://t.me/lingotalk")}
            >
              <TelegramIcon color="#ffffff" className={classes.icon} />
            </IconButton>
          </a>
          <a target="_blank" href="https://www.instagram.com/lingotalk.io/">
            <IconButton
              size="small"
              onClick={openLink("https://www.instagram.com/lingotalk.io/")}
            >
              <InstagramIcon color="#ffffff" className={classes.icon} />
            </IconButton>
          </a>{" "}
        </section>
      </footer>
    </section>
  );
}
